// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // serverUrl : 'http://192.168.3.6:8080',
  // serverUrl : 'http://192.168.3.22',
  // serverUrl: 'http://13.228.44.88'
  // serverUrl: "https://springboot.cyberstar.com.tw",
  // serverUrl:"http://localhost"
  serverUrl : location.protocol + "//" + location.hostname + ":" + location.port
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
